import { t } from 'i18next';
import moment from 'moment';
import { FC } from 'react';
import { TActivityHistory } from '../../../../../shared/types/activitiesTypes';
import { safeCharacterName } from '../../../../../../../shared/common/utils';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';
import { ClassIcon } from '../../../../../../../shared/frontend/scripts/wow/components/ClassIcon';
import { PossibleLink } from '../../../../../../../shared/frontend/components/link';
import { SpecIcon } from '../../../../../../../shared/frontend/scripts/wow/components/SpecIcon';
import { StreamTooltipContent } from '../../../../../../../shared/frontend/components/presentational/streamPreview';
import { naturalMonthAndDay, relativeDateShort } from '../../../../../../../shared/frontend/libs/utils';
import { ComplexTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';

export const RosterHistoryRow: FC<TActivityHistory> = (props) => {
  const { occurredAt, type, character, activeCharacterName } = props;

  if (!character) {
    return null;
  }

  return (
    <tr>
      <td className="text-muted">
        {moment.utc().diff(moment.utc(props.occurredAt), 'months') >= 1
          ? naturalMonthAndDay(occurredAt.toString())
          : relativeDateShort(occurredAt.toString())}
      </td>
      <td data-label={t('mplus-runs:character')} className="slds-cell-wrap">
        <ComplexTooltip
          placement="top"
          tooltip={
            <div className={`class-color--${character.class.slug}`}>
              {t('common:class-spec', {
                class: t(`game:classes.${character.class.slug}.name`),
                spec: t(`game:specs.${character.class.slug}.${character.spec.slug}.name`)
              })}
              {character.stream && <StreamTooltipContent type="twitch" stream={character.stream} count={1} />}
            </div>
          }
        >
          <span>
            {character.spec.slug ? (
              <span className="slds-avatar slds-avatar--xx-small slds-m-right--x-small rio-border--light rio-shadow--small">
                <SpecIcon class={character.class.slug} spec={character.spec.slug} />
              </span>
            ) : (
              <span className="slds-avatar slds-avatar--xx-small slds-m-right--x-small rio-border--light">
                <ClassIcon class={character.class.slug!} />
              </span>
            )}
          </span>

          <span className={character.stream ? 'streaming-now' : ''}>
            <PossibleLink
              allowLink={!character.anonymized}
              to={resolveRoutePath(namedRoutes.CharacterDetails, {
                region: character.region.slug,
                realm: character.realm.slug,
                character: character.name
              })}
              className={`class-color--${character.class.id}`}
            >
              {character.name && safeCharacterName(activeCharacterName || character.name)}
            </PossibleLink>
          </span>
        </ComplexTooltip>
      </td>
      <td className="slds-text-align--right">
        {t(`settings:group-privacy.activity-types.${type.replace('member_', '')}`)}
      </td>
    </tr>
  );
};
